<template>
  <div>
    <div class="upload-btn">
      <label for="upload-file">
        <i class="fas fa-file-alt"></i> Chọn file
        <input
          type="file"
          id="upload-file"
          @change="loadTextFromFile"
          style="display: none"
        />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => this.$emit("load", e.target.result);
      reader.readAsText(file);
    },
  },
};
</script>
<style scoped lang="scss">
.upload-btn {
  margin-right: 10px;
  padding: 7px 15px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #409eff;
  background-color: #ecf5ff;
  transition: 0.3s;
  cursor: pointer;
  font-size: 12px;
  text-transform: uppercase;
  &:hover {
    background-color: #409eff;
    color: #fff;
    border: 1px solid #409eff;
  }
  i {
    margin-right: 5px;
  }
}
label {
  cursor: pointer;
  margin-bottom: 0;
}
p {
  font-size: 15px;
  color: #606266;
  margin-bottom: 5px;
}
</style>
